import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/translation-en.json';
import translationVI from './locales/translation-vi.json';

const resources = {
    en: { translation: translationEN },
    vi: { translation: translationVI },
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'vi',
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false,
        }
    });

export default i18n;
